import React from 'react';
import Cookies from "js-cookie";
import { Popconfirm, message, Divider, Button } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import ManageAdd from './components/ManageAdd';
import CollectionScheduleAdd from './components/CollectionScheduleAdd';
import CollectionScheduleDetailed from './components/CollectionScheduleDetailed';
import SplitAccountAdd from './components/SplitAccountAdd';
import HsbChannelConfigAdd from './components/HsbChannelConfigAdd';
import { postFrom, config } from '../../axios';
import { dicMerchantType, dicMerchantStatus } from '../../axios/dictionaries';
import {API_merchant_clearSchedule} from "../../axios/config";

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: {
                keyword: '', //关键字
                merchantNo: '', //商户编号
                name: '', //全称
                shortName: '', //商户简称
                pageSize: 10
            }, //搜索参数
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
            showSplitAccountModal:false,
            createOrEdit: false, //默认为创建
            isMerchant: false //判断是否为商户显示新增
        }
        this.handleContractSearch = this.handleContractSearch.bind(this)
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
            showSplitAccountModal,
            showCollectionScheduleModal,
            showCollectionScheduleDetailedModal,
            showHsbPayChannelConfigModal,
            createOrEdit,
            isMerchant,
            onlyRead
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >

                <div className={`search-wrapper ${isMerchant ? "flex-justify-end" : ""}`}>
                    {  //平台管理商户, 如果为平台人员可以新增修改, 反之
                        isMerchant ?
                            ''
                            : <div className="search-btn-list">
                                <AuthButton authkey="h-1-2" type="primary" icon="plus" onClick={this.handleContractSearch}>新增</AuthButton>
                            </div>
                    }

                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                        showCancel={false}
                    />
                </div>
                <TableDOM
                    columns={columns({ current, handleDetail: this.handleDetail, handleEdit: this.handleEdit,handleSplitAccount:this.handleSplitAccount,
                        handleHsbPayChannelConfig:this.handleHsbPayChannelConfig,
                        handleDevice: this.handleDevice,
                        handleDelete: this.handleDelete,handleCollectionSchedule:this.handleCollectionSchedule,handleCollectionScheduleDetailed:this.handleCollectionScheduleDetailed,
                        handleClearSchedule:this.handleClearSchedule})}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <ManageAdd
                    onRef={ref => this.manageAddRef = ref}
                    visible={showAddModal}
                    onlyRead={onlyRead}
                    handlecreateOrEdit={createOrEdit}
                    handleGetList={this.handleSearch}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                />
                <SplitAccountAdd
                    onRef={ref => this.splitAccountAddRef = ref}
                    visible={showSplitAccountModal}
                    onlyRead={onlyRead}
                    handlecreateOrEdit={createOrEdit}
                    handleGetList={this.handleSearch}
                    handleCancel={() => { this.setState({ showSplitAccountModal: false }) }}
                />
                <CollectionScheduleAdd
                    onRef={ref => this.collectionScheduleAddRef = ref}
                    visible={showCollectionScheduleModal}
                    onlyRead={onlyRead}
                    handlecreateOrEdit={createOrEdit}
                    handleGetList={this.handleSearch}
                    handleCancel={() => { this.setState({ showCollectionScheduleModal: false }) }}
                />

                <CollectionScheduleDetailed
                    onRef={ref => this.collectionScheduleDetailedRef = ref}
                    visible={showCollectionScheduleDetailedModal}
                    onlyRead={onlyRead}
                    handlecreateOrEdit={createOrEdit}
                    handleGetList={this.handleSearch}
                    handleCancel={() => { this.setState({ showCollectionScheduleDetailedModal: false }) }}
                />

                <HsbChannelConfigAdd
                    onRef={ref => this.hsbChannelConfigAddRef = ref}
                    visible={showHsbPayChannelConfigModal}
                    onlyRead={onlyRead}
                    handlecreateOrEdit={createOrEdit}
                    handleGetList={this.handleSearch}
                    handleCancel={() => { this.setState({ showHsbPayChannelConfigModal: false }) }}
                />

            </PageWrap>
        )
    }

    componentDidMount() {
        this.handleSearch();

        if (Cookies.get('loginData')) {
            let loginData = JSON.parse(Cookies.get('loginData'))
            for (let key in loginData) {
                if (key == 'merchantId' && loginData[key]) { //商户
                    this.setState({ isMerchant: true })
                }
            }
        }
    }

   handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true, createOrEdit: true, onlyRead: false })
        this.manageAddRef.loadPack({ id });
        this.manageAddRef.passTypeUpdate(false);
    }

    handleSplitAccount = (id) => { //编辑
        this.setState({ showSplitAccountModal: true, createOrEdit: true, onlyRead: false })
        this.splitAccountAddRef.loadPack({ id });
       // this.splitAccountAddRef.passTypeUpdate(false);
    }

    handleCollectionSchedule = (id,shortName) => { //编辑
        this.setState({ showCollectionScheduleModal: true, createOrEdit: true, onlyRead: false })
        this.collectionScheduleAddRef.loadPack({ id,shortName });
        // this.splitAccountAddRef.passTypeUpdate(false);
    }

    handleCollectionScheduleDetailed  = (id,shortName) => { //编辑
        this.setState({ showCollectionScheduleDetailedModal: true, createOrEdit: false, onlyRead: true })
        this.collectionScheduleDetailedRef.loadPack({ id,shortName });
        // this.splitAccountAddRef.passTypeUpdate(false);
    }

    handleHsbPayChannelConfig = (id) => { //编辑
        this.setState({ showHsbPayChannelConfigModal: true, createOrEdit: true, onlyRead: false })
        this.hsbChannelConfigAddRef.loadPack({ id });
        // this.splitAccountAddRef.passTypeUpdate(false);
    }


    handleDevice = (id) => {
        this.props.history.push('/admin/merchant/device?merchantId=' + id)
    }

    handleDetail = (id, onlyRead) => {
        this.setState({ showAddModal: true, createOrEdit: true, onlyRead: true })
        this.manageAddRef.loadPack({ id });
        this.manageAddRef.postApilogFindPage({id})
        this.manageAddRef.postProjectFindPage({id})
        this.manageAddRef.passTypeUpdate(false);
    }

    handleContractSearch = () => { //新增

        this.setState({ showAddModal: true, createOrEdit: false, onlyRead: false })

        this.manageAddRef.passTypeUpdate(true);
    }

    handleClearSchedule =(id) =>{// 清空租金汇集计划
        this.setState({ loading: true });
        let data = { merchantId: id };
        postFrom({
            url: config.API_merchant_clearSchedule,
            data,
        }).then(res => {
            this.setState({ loading: false });
            this.handleSearch();
            message.success(`租金汇集计划清空完成`);
        }).catch(err => {
            message.error(err.message || '接口异常');
            this.setState({ loading: false });
        })
    }


    handleDelete = (id) => { //删除

        this.setState({ loading: true });
        let data = { merchantId: id };
        postFrom({
            url: config.API_merchant_delMerchant,
            data,
        }).then(res => {
            this.setState({ loading: false });
            this.handleSearch();
            message.success(`删除成功`);
        }).catch(err => {
            message.error(err.message || '接口异常');
            this.setState({ loading: false });
        })
    }

    handleSearch = (values = {}) => { //表单搜索/分页

        let { params, current } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({
            url: config.API_merchant_findPage,
            data,
        }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });

    }
}

const searchData = () => [
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字 ', style: { width: '160px' } },
        title: '在商户简称/编号内模糊查询'
    },
];
const columns = ({handleDetail, handleEdit,handleSplitAccount,handleHsbPayChannelConfig,handleDevice, handleDelete, handleCollectionSchedule,handleCollectionScheduleDetailed,handleClearSchedule}) => [

    {
        title: '商户编号',
        dataIndex: 'merchantNo'
    },
    {
        title: '商户简称',
        dataIndex: 'shortName'
    },
    {
        title: '商户类型',
        dataIndex: 'merchantType',
        render(text, record, index) {

            let now = dicMerchantType.find(item => item.value == text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '使用状态',
        dataIndex: 'status',
        render(text, record, index) {
            let now = dicMerchantStatus.find(item => parseInt(item.value) === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        render(text, record, index) {
            return (<div>
                <span className="showClickDetail" onClick={() => { handleDetail(record.id) }}>详情</span>
                <Divider type="vertical" />
                <AuthButton authkey="h-1-3"><span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span></AuthButton>
                <Divider type="vertical" />
                <AuthButton authkey="h-1-4">
                    <Popconfirm placement="top" title={"确定删除吗？"} onConfirm={() => { handleDelete(record.id) }} okText="确定" cancelText="不了">
                        <span className="showClickDetail">删除</span>
                    </Popconfirm>
                </AuthButton>
                <Divider type="vertical" />
                <AuthButton authkey="h-1-5"><span className="showClickDetail" onClick={() => { handleSplitAccount(record.id) }}>分账配置</span></AuthButton>
                {record.createCollectionPlan?
                <AuthButton authkey="h-1-7"> <Divider type="vertical" /><span className="showClickDetail" onClick={() => { handleCollectionSchedule(record.id,record.shortName) }}>创建租金汇集计划</span></AuthButton>:null}
                {record.collectionPlanInfo ?
                    <AuthButton authkey="h-1-8"> <Divider type="vertical"/><span className="showClickDetail"
                                                                                 onClick={() => {
                                                                                     handleCollectionScheduleDetailed(record.id, record.shortName)
                                                                                 }}>租金汇集计划详情</span></AuthButton>:null
                }
                {record.resetCollectionPlan ?
                    <AuthButton authkey="h-1-9"> <Divider type="vertical"/><Popconfirm placement="top" title={"确定清空吗？"} onConfirm={() => { handleClearSchedule(record.id) }} okText="确定" cancelText="不了">
                    <span className="showClickDetail">清空租金汇集计划</span>
                    </Popconfirm></AuthButton>:null
                }

                {record.isDeviceLease ?
                <AuthButton authkey="h-1-10"><Divider type="vertical" /><span className="showClickDetail" onClick={() => { handleDevice(record.id) }}>设备管理</span></AuthButton>:null
                }
            </div>)
        }
    }
];



// WEBPACK FOOTER //
// ./src/page/Merchant/Manage.js